import { Component, Vue, Watch } from 'vue-property-decorator';
import OrderDetails from '../OrderDetails/OrderDetails.vue';
import { mapState } from 'vuex'

@Component({
    components:{
        OrderDetails,
    }
})
export default class Body extends Vue{
    public log: any;
    constructor(){
        super();
        // console.log(this.isLoggedIn);
        
    }
    // public data(){
    //     return{
    //         isLoggedIn: false,
    //     }
    // }
    
    
    mounted(): void{
        
    }
    
    getLoginsStatus():void{
        return this.$store.getters.getLoginStatus;
    }

     get isUserLoggedIn(){
        return this.$store.getters.getLoginStatus;
    }

    get isAdminUser(){
        return this.$store.getters.getAdminStatus;
    }

    destroy():void{
    }
}